import type { CookiePreferences } from "./types";

export const COOKIE_CONSENT_STORAGE_KEY = "flowly-cookie-consent";

export const DEFAULT_PREFERENCES: CookiePreferences = {
  hasConsented: false,
  analytics: false,
  consentTimestamp: null,
};
